module.exports = "/images/emptyBasket-v5.svg";